import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { SitesCodeService } from '../sites-code.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from 'src/app/shared/utils.service';
import { ApiResponseModel } from 'src/app/models/api-response.model';
import { CodeModel } from 'src/app/models/code.model';
import { RBACService } from '../../../shared/rbac.service';

@Component({
  selector: 'app-codes-claim',
  templateUrl: './sites-codes-claim.component.html',
  styleUrls: ['./sites-codes-claim.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SitesCodesClaimComponent implements OnInit {
  paper_id: string;

  inProgress: boolean = false;

  constructor(
    private codeService: SitesCodeService,
    @Inject(MAT_DIALOG_DATA) public data: { site_id: number },
    private utils: UtilsService,
    private dialogRef: MatDialogRef<SitesCodesClaimComponent>,
    private rbac: RBACService
  ) {}

  ngOnInit() {
    // Check permissions - user must have sites:view AND sites-qr-codes:create
    if (
      !this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES,
            RBACService.RBAC_A.A_VIEW
          ),
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES_QR_CODES,
            RBACService.RBAC_A.A_CREATE
          )
        ],
        true
      )
    ) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to claim QR codes.'
      );
      this.dialogRef.close(false);
      return;
    }
  }

  claim() {
    // Check permissions - user must have sites:view AND sites-qr-codes:create
    if (
      !this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES,
            RBACService.RBAC_A.A_VIEW
          ),
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES_QR_CODES,
            RBACService.RBAC_A.A_CREATE
          )
        ],
        true
      )
    ) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to claim QR codes.'
      );
      return;
    }

    if (this.inProgress) {
      return;
    }

    this.inProgress = true;

    this.codeService.claimCode(this.data.site_id, this.paper_id).subscribe(
      (result: ApiResponseModel<CodeModel>) => {
        this.utils.showToast(`Claimed QR Code: ${result.data.name}`);
        this.inProgress = false;
        this.dialogRef.close(true);
      },
      () => {
        this.inProgress = false;
      }
    );
  }
}
